<div class="card card-custom m-2" style="position: relative">
  <div (click)="openEditFlowModal()">
    <div class="card-header card-header-right ribbon ribbon-left">
      <div
        [class]="getHeaderStyle(workflow.workflow_queue.old_workflow_queue_id)"
        style="top: 10px; left: -2px"
      >
        {{ workflow.workflow_queue.workflow.name | titlecase }}
      </div>
    </div>
    <div
      *ngIf="assignedUsers.length"
      class="assigned-users symbol-group symbol-hover justify-content-center"
    >
      <div
        *ngIf="assignedUsers.length > 0"
        [matTooltip]="assignedUsers[0].fullName"
        matTooltipPosition="above"
      >
        <kt-user-photo
          [size]="30"
          [create]="'false'"
          [type]="'object'"
          [editable]="false"
          [user$]="assignedUsers[0]"
        ></kt-user-photo>
      </div>
      <div
        *ngIf="assignedUsers.length > 1"
        class="symbol symbol-30 symbol-circle symbol-light-primary"
      >
        <span
          [matTooltip]="getFullNames(assignedUsers, 1)"
          matTooltipPosition="above"
          class="symbol-label font-weight-bold"
        >
          {{ assignedUsers.length - 1 }}+
        </span>
      </div>
    </div>
    <div class="row card-block">
      <div class="col m-5" [innerHTML]="getDescription() | safe : 'html'"></div>
    </div>
    <div
      class="btn rounded-bottom btn-square border-top bg-hover-light"
      style="display: flex; flex-direction: row; justify-content: space-between"
    >
      <div
        *ngIf="workflow.last_modified_user"
        class="card-text text-capitalize text-dark-50"
        style="align-items: flex-end"
      >
        <i class="flaticon2-user icon-nm" matTooltip="{{ workflow.last_modified_user }}"></i>
        <small class="ml-1 text-muted">{{ workflow.workflow_queue.created | date }}</small>
        <a (click)="clickPin(workflow.workflow_queue); $event.stopPropagation()">
          <span [class]="getPinCSS(workflow.workflow_queue)"
            ><!--begin::Svg Icon | path:/var/www/preview.keenthemes.com/metronic/releases/2020-12-28-020759/theme/html/demo1/dist/../src/media/svg/icons/Communication/Clipboard-check.svg--><svg
              xmlns="http://www.w3.org/2000/svg"
              width="24px"
              height="24px"
              viewBox="0 0 24 24"
              version="1.1"
            >
              <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <rect x="0" y="0" width="24" height="24" />
                <path
                  d="M11.6734943,8.3307728 L14.9993074,6.09979492 L14.1213255,5.22181303 C13.7308012,4.83128874 13.7308012,4.19812376 14.1213255,3.80759947 L15.535539,2.39338591 C15.9260633,2.00286161 16.5592283,2.00286161 16.9497526,2.39338591 L22.6066068,8.05024016 C22.9971311,8.44076445 22.9971311,9.07392943 22.6066068,9.46445372 L21.1923933,10.8786673 C20.801869,11.2691916 20.168704,11.2691916 19.7781797,10.8786673 L18.9002333,10.0007208 L16.6692373,13.3265608 C16.9264145,14.2523264 16.9984943,15.2320236 16.8664372,16.2092466 L16.4344698,19.4058049 C16.360509,19.9531149 15.8568695,20.3368403 15.3095595,20.2628795 C15.0925691,20.2335564 14.8912006,20.1338238 14.7363706,19.9789938 L5.02099894,10.2636221 C4.63047465,9.87309784 4.63047465,9.23993286 5.02099894,8.84940857 C5.17582897,8.69457854 5.37719743,8.59484594 5.59418783,8.56552292 L8.79074617,8.13355557 C9.76799113,8.00149544 10.7477104,8.0735815 11.6734943,8.3307728 Z"
                  fill="#000000"
                />
                <polygon
                  fill="#000000"
                  opacity="0.3"
                  transform="translate(7.050253, 17.949747) rotate(-315.000000) translate(-7.050253, -17.949747) "
                  points="5.55025253 13.9497475 5.55025253 19.6640332 7.05025253 21.9497475 8.55025253 19.6640332 8.55025253 13.9497475"
                />
              </g>
            </svg>
          </span>
        </a>
        <span
          [inlineSVG]="'./assets/media/svg/icons/Code/Warning-2.svg'"
          *ngIf="workflow.show_alert"
          class="svg-icon svg-icon-md svg-icon-warning"
          matTooltip="the request has been in this state for more than 72 hours."
        >
        </span>
        <span
          [inlineSVG]="'./assets/media/svg/icons/Code/Warning-1-circle.svg'"
          *ngIf="workflow.note && workflow.note.length"
          class="svg-icon svg-icon-md svg-icon-danger"
          matTooltip="Note : {{ workflow.note }}"
        >
        </span>
      </div>
      <div class="d-flex align-items-center">
        <div style="width: 24px" class="d-flex flex-center mr-2">
          <img
            *ngIf="workflow.blockers?.length"
            [matTooltip]="getBlockersString(workflow.blockers)"
            src="./assets/media/svg/icons/General/blocker.svg"
            alt="Blocker Icon"
            class="w-100"
          />
        </div>
        <div
          matTooltip="Follow-Up"
          class="symbol symbol-20 cursor-pointer mr-2"
          (click)="openFollowUp($event)"
        >
          <div class="symbol-label bg-transparent">
            <i class="flaticon-calendar-with-a-clock-time-tools icon-lg"></i>
          </div>
          <i *ngIf="workflow.has_followup" class="symbol-badge bg-danger"></i>
        </div>
        <div
          class="symbol symbol-20 cursor-pointer"
          matTooltip="Comments"
          (click)="openComments($event)"
        >
          <div class="symbol-label bg-transparent">
            <i class="flaticon2-chat-1 icon-lg"></i>
          </div>
          <i *ngIf="workflow.has_comments" class="symbol-badge bg-danger"></i>
        </div>
      </div>
    </div>
  </div>
  <div class="lock-overlay rounded" *ngIf="locked" (click)="unlockCard()">
    <div class="overlay-content">
      <div class="overlay-icon">
        <span class="material-icons"> lock_open </span>
      </div>
      <div style="font-size: 13px !important; text-align: center">
        this card is locked by {{ lockedBy }} <br />press to unlock
      </div>
    </div>
  </div>
</div>
